import { WppTypography } from '@wppopen/components-library-react'
import styles from './NoneAddedRender.module.scss'

export const NoneAddedRender = () => {
  return (
    <WppTypography type="xs-body" tag="p" className={styles.noneAdded}>
      None added
    </WppTypography>
  )
}
